import PropTypes from 'prop-types';
import React from 'react';
import Dialog from './Dialog';
import { translate } from '../../../common/i18n';

// [strategy id, name] — ids are the xml/bots strategies the store loads
const NEW_BOTS = [
    ['bot_insano', 'Bot Insano'],
    ['bot_ultimate_premium', 'Bot Premium Ultimate'],
    ['lucrum', 'Lucrum'],
    ['robo_segue_2025', 'Robo Segue 2025'],
    ['spiderbot_5', 'Spiderbot 5.0'],
];
const ALL_BOTS = [
    ['90_porcento', '90 Porcento'],
    ['barrier_bb8', 'Barrier BB 8'],
    ['bear_market_put', 'Bear Market Put'],
    ['bethoven', 'Bethoven'],
    ['binarios_com_3_estrategias', 'Bin\u00e1rios com 3 estrat\u00e9gias'],
    ['blaze', 'Blaze'],
    ['bola_azul_sem_martingale', 'Bola Azul Sem Martingale'],
    ['bola_azul_y_roja', 'Bola Azul Y Roja'],
    ['boot_4', 'Boot 4.0'],
    ['botpremium_probot', 'Bot Premium Pro Bot'],
    ['bull', 'Bull'],
    ['cash_5.0', 'Cash 5.0'],
    ['dubai_2', 'Dubai 2.0'],
    ['dynamic_over_zero', 'Dynamic Over Zero'],
    ['elon_musk_differs', 'Elon Musk Differs'],
    ['ema_rsi_rf_bot', 'EMA + RSI RF'],
    ['estrategia_somente_par', 'Estrat\u00e9gia Somente Par'],
    ['even_fenix', 'Even Fenix'],
    ['evo_part2_m7_virals_channel', 'Evo Part2 M7 Virals Channel'],
    ['extreme_bot', 'Extreme Bot'],
    ['fox_money_call', 'Fox Money Call'],
    ['grenade', 'Grenade'],
    ['gringo_barreiras', 'Gringo Barreiras'],
    ['harpia_banca_pequena', 'Harpia Banca Pequena'],
    ['hl_axe_v2', 'HL Axe V2.0.1'],
    ['kevin_cash', 'Kevin Cash'],
    ['lionel', 'Lionel'],
    ['mano_de_dios', 'Mano de Dios'],
    ['master_even_odd', 'Master Even Odd'],
    ['mavic_air_rf', 'Mavic Air RF Vix'],
    ['megalodon', 'Megalodon'],
    ['metawave', 'Metawave'],
    ['next_2', 'Next 2.0'],
    ['odyssey_xl', 'Odyssey XL'],
    ['one_touch', 'One Touch'],
    ['over_1', 'Over 1'],
    ['over_turtle', 'Over Turtle'],
    ['over_under_stan_lee', 'Stan Lee'],
    ['payticks_2', 'Pay Ticks'],
    ['qatar', 'Bot Qatar'],
    ['reset_call_put_2023', 'Reset Call Put 2023'],
    ['rf_compressor_signal_bot', 'RF Compressor Signal'],
    ['rise_fall_alternado', 'Rise Fall Alternado'],
    ['rise_fall_analises_ticks', 'Rise Fall Analises Ticks'],
    ['rise_fall_color_analysis', 'Rise Fall Color Analysis'],
    ['rise_fall_gale_parcelado', 'Rise Fall Gale Parcela'],
    ['rita_3', 'Rita 3'],
    ['rush', 'Rush'],
    ['skylander_differs_com_soros', 'Skylander Differs Com Soros'],
    ['sniper_americana', 'Sniper Americano'],
    ['snowman', 'Snowman Bot'],
    ['solo_par_impar', 'Solo Par Impar'],
    ['soros_touch_no_touch', 'Soros Touch No Touch'],
    ['step_100_baja', 'Step 100 Baja'],
    ['super_ganador_10', 'Super Ganador 10'],
    ['super_rise_fall_premium', 'Super Rise Fall Premium'],
    ['superfast_rf', 'Superfast RF'],
    ['superior_4', 'Superior 4'],
    ['the_match_box_over', 'The Match Box Over'],
    ['tick_azul_94', 'Tick Azul 94'],
    ['tick_pip_rf', 'Tick Pip RF'],
    ['turbo_4', 'Turbo 4.0'],
    ['under_7_vitoria_rapida', 'Under 7 Vitoria Rapida'],
    ['under_profit_bajo', 'Under Profit Bajo'],
    ['unicorn_only_up_down', 'Unicorn Only Up/Down'],
    ['winner_5.0', 'Winner 5.0'],
];

const Save = React.memo(({ onChange }) => (
    <div className="bb3-dlg-b bb3-groups">
        {[
            ['New Strategies', NEW_BOTS, 'bb3-new'],
            ['All bots', ALL_BOTS],
        ].map(([group, bots, className]) => (
            <section key={group} className={className}>
                <h3>{translate(group)}</h3>
                <ul className="bb3-chips">
                    {bots.map(([id, name]) => (
                        <li key={id}>
                            <button type="button" onClick={() => onChange(id)}>
                                {name}
                            </button>
                        </li>
                    ))}
                </ul>
            </section>
        ))}
    </div>
));

Save.propTypes = {
    onChange: PropTypes.func.isRequired,
};

export default class StoreDialog extends Dialog {
    constructor() {
        const closeDialog = () => {
            this.close();
        };

        const onChange = arg => {
            this.limitsPromise(arg);
            closeDialog();
        };
        super('store-dialog', translate('Bot Store'), <Save closeDialog={closeDialog} onChange={onChange} />, {
            height   : 'auto',
            width    : 980,
            resizable: false,
            classes  : { 'ui-dialog': 'bb3-dlg bb3-dlg-lg', 'ui-dialog-titlebar-close': 'icon-close' },
        });
        this.registerCloseOnOtherDialog();
    }

    change() {
        this.open();
        return new Promise(resolve => {
            this.limitsPromise = resolve;
        });
    }
}
